import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

export const AuthGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const router = inject(Router)

  let tokenLogIn = sessionStorage.getItem('tokenLogIn');

  if (tokenLogIn !== null) {
    return true;
  } else {
    sessionStorage.setItem('intendedRoute', state.url);
    router.navigate(['/home'], { queryParams: { requireAuth: 'true' } });
    return false;
  }
};